export enum AuthRoutes {
  login = '/login',
  register = '/register',
  logout = '/logout',
  forgotPassword = '/forgot-password',
  resetPassword = '/reset-password/:token',
  createAccount = '/create-account/:token',
  expiredLink = '/magic-link-expired',
  pylonLogin = '/pylon-login',
}

export enum DashboardRoutes {
  root = '/',
  legacyRoot = '/dashboard',
}

export enum InboxRoutes {
  root = '/inbox',
}

export enum NetworkRoutes {
  root = '/network',
  deprecatedRoot = '/trade-partners',
  connectionDetails = '/network/partner/:partnerId',
  deprecatedRelationshipDetails = '/network/partner/relationship/:relationshipId',
  relationshipDetails = '/network/partner/:partnerId/relationship/:relationshipId',
  relationshipTransactions = '/network/partner/:partnerId/relationship/:relationshipId/transactions',
  relationshipSetup = '/network/partner/:partnerId/relationship/:relationshipId/setup',
  relationshipNotifications = '/network/partner/:partnerId/relationship/:relationshipId/notifications',
  testRelationship = '/network/partner/:partnerId/relationship/:relationshipId/test',
  testRelationshipMessageDetails = '/network/partner/:partnerId/relationship/:relationshipId/test/message/:messageId',
  testRelationshipTransactionError = '/network/partner/:partnerId/relationship/:relationshipId/test/transaction/:transactionId/error',
  goLiveRelationship = '/network/partner/:partnerId/relationship/:relationshipId/go-live',
  instantConnectivity = '/network/partner/:partnerId/relationship/:relationshipId/instant-connectivity',
  taskDetails = '/network/partner/:partnerId/relationship/:relationshipId/task/:taskId',
}

export enum PartnerSearchRoutes {
  root = '/partner-search',
}

export enum PricingConfigRoutes {
  root = '/price-lists',
  view = '/price-lists/:partnerId/:id',
  new = '/price-lists/new',
}

export enum PriceCatalogRoutes {
  root = '/price-catalogs',
  relationshipDetails = '/price-catalogs/:relationshipId',
  viewMessage = '/price-catalogs/message/:id',
  viewSenderEnvelope = '/price-catalogs/sender-envelope/:id',
  create = '/price-catalogs/relationship/:relationshipId/create/:messageType',
}

export enum MetabaseRoutes {
  root = '/reports',
}

export enum TransactionsRoutes {
  root = '/transactions',
  errors = '/transactions?filter[transaction_state]=FAILED&filter[transaction_flow]=LIVE',
  viewMessage = '/transactions/message/:id',
  viewSenderEnvelope = '/transactions/sender-envelope/:id',
  createStandalone = '/transactions/relationship/:relationshipId/create/:messageType',
  create = '/transactions/message/:id/create/:messageType',
  edit = '/transactions/message/:id/edit',
  editSuggestion = '/transactions/message/:id/edit/suggestion',
  reprocess = '/transactions/message/:id/reprocess',
  blocked = '/transactions/blocked',
  expired = '/transactions/expired',
}

export enum PaymentReconciliationRoutes {
  root = '/payment-reconciliation',
  pitch = '/payment-reconciliation-pitch',
  detail = '/payment-reconciliation/:id',
}

export enum ConnectionsRoutes {
  root = '/connections',
  connectionDetails = '/connections/partner/:partnerId',
  deprecatedRelationshipDetails = '/connections/partner/relationship/:relationshipId',
  relationshipDetails = '/connections/partner/:partnerId/relationship/:relationshipId',
  relationshipTransactions = '/connections/partner/:partnerId/relationship/:relationshipId/transactions',
  relationshipSetup = '/connections/partner/:partnerId/relationship/:relationshipId/setup',
  relationshipNotifications = '/connections/partner/:partnerId/relationship/:relationshipId/notifications',
  testRelationship = '/connections/partner/:partnerId/relationship/:relationshipId/test',
  testRelationshipMessageDetails = '/connections/partner/:partnerId/relationship/:relationshipId/test/message/:messageId',
  testRelationshipTransactionError = '/connections/partner/:partnerId/relationship/:relationshipId/test/transaction/:transactionId/error',
  goLiveRelationship = '/connections/partner/:partnerId/relationship/:relationshipId/go-live',
  instantConnectivity = '/connections/partner/:partnerId/relationship/:relationshipId/instant-connectivity',
  taskDetails = '/connections/partner/:partnerId/relationship/:relationshipId/task/:taskId',
}

export enum SettingsRoutes {
  root = '/settings',
  companyData = '/settings/company-data',
  ssccSettings = '/settings/sscc',
  teamMembers = '/settings/team-members',
  profileAndPreferences = '/settings/profile-preferences',
  password = '/settings/password',
  notificationsManagement = '/settings/notifications-management',
  usageAndModules = '/settings/usage-and-modules',
  productMasterdata = '/settings/product-masterdata',
  documentUnderstandingAgent = '/settings/document-understanding-agent',
}

export enum InvoiceVerificationRoutes {
  root = '/invoice-verification',
  detail = '/invoice-verification/:invoiceId',
}

export enum OrderFormsRoutes {
  pitch = '/order-forms',
  root = '/order-form/:supplierSlug',
  checkout = '/order-form/:supplierSlug/checkout',
  successSenderEnvelope = '/order-form/:supplierSlug/success/sender-envelope/:id',
  successMessage = '/order-form/:supplierSlug/success/message/:id',
  login = '/order-form/:supplierSlug/login',
  unauthorized = '/order-form/:supplierSlug/unauthorized',
}

export enum InternalRoutes {
  tasksPreview = '/internal/tasks-preview',
  tasksPreviewTask = '/internal/tasks-preview/:taskId',
}
